import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';
import { z } from 'zod';
import { ActivityPage, CATEGORIES, PERIODS, type ActivityPageFilters } from '@/modules/audit/public';
import { RequirePermission } from '@/modules/identity/public';

export const Route = createFileRoute('/_admin/atividade')({
  validateSearch: z.object({
    categoria: z.enum(CATEGORIES).optional().catch(undefined),
    periodo: z
      .enum(PERIODS.map((p) => p.value))
      .optional()
      .catch(undefined),
    busca: z.string().max(100).optional().catch(undefined),
  }),
  component: function ActivityRoute() {
    const { categoria, periodo, busca } = Route.useSearch();
    const navigate = Route.useNavigate();
    const onChange = useCallback(
      (next: ActivityPageFilters) =>
        void navigate({
          search: {
            categoria: next.category,
            periodo: next.period === '7d' ? undefined : next.period,
            busca: next.q,
          },
          replace: true,
        }),
      [navigate],
    );
    return (
      <RequirePermission anyOf={['auditoria.ver']}>
        <ActivityPage
          filters={{ category: categoria, period: periodo ?? '7d', q: busca }}
          onChange={onChange}
        />
      </RequirePermission>
    );
  },
});
